import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact">
      <h1 className="contact__title">Let's Discuss Your Project</h1>
      <div className="contact-wrapp">
      <img src="https://www.zazmic.com/wp-content/uploads/2021/06/googlozazmic-1.png" alt="contact" className="contact__img" /></div>
      <p className="contact__text">At Zazmic, we take pride in delivering excellent IT solutions that enable our clients to focus on their core businesses. Contact us today to learn more about how we can help you achieve your business goals.</p>
    <button className="contact__btn">Contact Us</button>
    </div>
  );
};

export default Contact;
